import { SortType } from "../constants/enums"

export const searchSort = value => {
  const sort = (a, b) => {
    if (value.optionSort === "lowestPrice") {
      return (
        +a.currentPrice.substr(1).replace(/,/g, "") -
        +b.currentPrice.substr(1).replace(/,/g, "")
      )
    }
    if (value.optionSort === "highestPrice") {
      return (
        +b.currentPrice.substr(1).replace(/,/g, "") -
        +a.currentPrice.substr(1).replace(/,/g, "")
      )
    }

    if (value.optionSort === "alphabetically") {
      const titleA = a.title.toLowerCase(),
        titleB = b.title.toLowerCase()
      if (titleA < titleB) {
        return -1
      }
      if (titleA > titleB) {
        return 1
      }
    }

    if(value.optionSort === SortType.TIMESTAMP) {
      const timestampA = new Date(a.timestamp).getTime()
      const timestampB = new Date(b.timestamp).getTime()

      if (timestampA < timestampB) {
        return -1
      }
      if (timestampA > timestampB) {
        return 1
      }
    }

    return 0
  }
  return sort
}
